// extracted by mini-css-extract-plugin
module.exports = {"addressCardsWrapper":"EditAddress_addressCardsWrapper__0_s3a"};